module.exports = __webpack_public_path__ + "static/upsell-3-f2b959e75a586eb2d6e4e21183865f2d.png";